// extracted by mini-css-extract-plugin
export default {"Banner":"BannerItem_Banner__oC7wx","Img":"BannerItem_Img__lHY4U","Text":"BannerItem_Text__uNoLN","ImageOnly":"BannerItem_ImageOnly__WfMAO"};